import { IconProps } from '@service-victoria/component-library/components/Icons';
import * as Styled from './styled';

interface DashboardButtonProps {
  title: string;
  description: string;
  icon: React.FC<IconProps>;
  onClick: () => void;
}

export default function DashboardButton(props: DashboardButtonProps) {
  return (
    <Styled.DashboardButton onClick={props.onClick}>
      <Styled.DashboardButtonTitleWrapper>
        <props.icon />
        <Styled.DashboardButtonTitle>{props.title}</Styled.DashboardButtonTitle>
      </Styled.DashboardButtonTitleWrapper>
      <Styled.DashboardButtonDescription>{props.description}</Styled.DashboardButtonDescription>
    </Styled.DashboardButton>
  );
}
